import React from 'react';
import PropTypes from 'prop-types';
import { Popover } from 'antd';
import { map, split } from 'lodash';
import { TextWrapper, EllipsisPop } from './styled';

/**
 * Ellipsis
 * @param value {string}
 * @param pop {bool}
 * @returns {JSX.Element}
 */
const Ellipsis = ({ value, pop = false, popPlacement = 'left' }) => {
  const val = value ? value : '-';
  return (
    <>
      {value ? (
        pop && (
          <Popover
            placement={popPlacement}
            content={
              <div style={{ padding: 4 }}>
                {map(split(value, ', '), (item, idx) => (
                  <EllipsisPop key={`list_${idx}`}>{`- ${item}`}</EllipsisPop>
                ))}
              </div>
            }>
            <TextWrapper>{value}</TextWrapper>
          </Popover>
        )
      ) : (
        <TextWrapper>{val}</TextWrapper>
      )}
      {!pop && <TextWrapper>{val}</TextWrapper>}
    </>
  );
};

Ellipsis.propTypes = {
  value: PropTypes.string,
  pop: PropTypes.bool,
  popPlacement: PropTypes.string
};

export default Ellipsis;
